import { combineReducers } from 'redux';

import { StoreConstant } from '../constants';

import AuthReducer from './auth.reducer';
import ColorReducer from './color.reducer';
import CustomerReducer from './customer.reducer';
import InstallmentReducer from './installment.reducer';
import ModalReducer from './modal.reducer';
import OfficeReducer from './office.reducer';
import PermissionReducer from './permission.reducer';
import PurchaseReducer from './purchase.reducer';
import ReportReducer from './report.reducer';
import RoleReducer from './role.reducer';
import SaleReducer from './sale.reducer';
import StockReducer from './stock.reducer';
import UserReducer from './user.reducer';
import VehicleReducer from './vehicle.reducer';

const appReducer = combineReducers({
  auth: AuthReducer,
  color: ColorReducer,
  customer: CustomerReducer,
  installment: InstallmentReducer,
  modal: ModalReducer,
  office: OfficeReducer,
  permission: PermissionReducer,
  purchase: PurchaseReducer,
  report: ReportReducer,
  role: RoleReducer,
  sale: SaleReducer,
  stock: StockReducer,
  user: UserReducer,
  vehicle: VehicleReducer,
});

const rootReducer = (state, action) => {
  if (action.type === StoreConstant.RESET_STORE) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
